module.exports = __webpack_public_path__ + "img/image.cb17b914.svg";